//@ts-nocheck
import { useMemo } from "react";
import { useCacheStatus, usePhases } from "@/state/cacheStoreHooks";
import { analyzeGame } from "./balancing.utils";
import { TotalSummary } from "./components/TotalSummary";
import { PhaseCard } from "./components/PhaseCard";
import { useCacheStore } from "@/state/cacheStore";

export function BalancingDashboard() {
    const { status, error } = useCacheStatus();
    const fetchData = useCacheStore((state) => state.fetchData);
    const phases = usePhases();

    const gameAnalysis = useMemo(() => {
        if (!phases || phases.length === 0) return null;
        return analyzeGame(phases);
    }, [phases]);

    if (!gameAnalysis) {
        return (
            <div className="p-8">
                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                    <p className="text-sm text-yellow-800">
                        No phase data available. Please ensure content is loaded from Strapi.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="size-full overflow-y-scroll relative text-gray-800 py-10">
            {status === "loading" && <div className="absolute inset-0 backdrop-grayscale-100" />}
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <div className="mb-6">
                    <div className="flex items-center justify-between">
                        <h1 className="text-3xl font-bold text-gray-900 mb-2">Game Balancing Dashboard</h1>
                        <button onClick={fetchData} className="cursor-pointer rounded bg-blue-500 px-4 py-2 text-white hover:bg-blue-600">
                            Refresh Strapi Data
                        </button>
                    </div>
                    <p className="text-gray-600">
                        Analyze stat distributions across all phases to ensure balanced gameplay.
                    </p>
                </div>

                {/* Total summary */}
                <TotalSummary total={gameAnalysis.total} />

                {/* Phase breakdown */}
                <div className="space-y-4">
                    {gameAnalysis.phases.map((phase, idx) => (
                        <PhaseCard key={phase.phaseId} phase={phase} phaseNumber={idx + 1} />
                    ))}
                </div>
            </div>
        </div>
    );
}
